export enum SaveIntegrationEvents {
  InitSaveIntegrationForm = 'initSaveIntegrationForm',
  ReloadGrid = 'reloadGrid',
  Cancel = 'cancelSaveIntegration',
  Delete = 'deleteIntegration',
  Stop = 'stopIntegration',

  Start = 'startIntegration',
  ViewLogs = 'viewLogs',
}

// TODO: specifics type should be generic based on integration type and not all defined here.
export interface NewIntegration {
  name: string;
  type: number;
  companyId: string;
  specifics: Partial<{
    // Specifics for VMWare Integration
    hostname: string;
    port: number;
    username: string;
    password: string;
    retryAuthentication?: boolean;
    retryAuthenticationMaxAttempts: number;
    retryAuthenticationTimeToWait: number;
    verifyTLSCertificate: boolean;
    viewType: number;

    // Specifics for Container Image Scanner Integration
    userCreated: boolean;
  }>;
}

export interface SaveIntegrationWebComponentSchema {
  // all the data needed for rendering
}
